// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_25d45facb5--tooltip--Hs2ji"};